import React, { useState } from "react";
import Sidebar from "../sidebar/Sidebar";
import ProfilePic from "../sidebar/ProfilePic";
import Overview from "./Overview";
import "./Dashboard.scss";
import { useSelector } from "react-redux";
import CampaignsTable from "./CampaignsTable";
import AppliedCampaignTable from "./AppliedCampaignTable";
import useGetAppliedCampaigns from "../../utils/useGetAppliedCampaigns";
// import Footer from "../Footer";

const Dashboard = ({ onLogout }) => {
  const [page, setPage] = useState(0);
  const [campaignType, setCampaignType] = useState("");
  const [campaignStatus, setCampaignStatus] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const influencerDetails = useSelector(
    (store) => store?.influencer?.influencer
  );
  // const isLoading = useSelector((store) => store?.influencer?.isLoading);

  const [isLoading, allAppliedCampaigns] = useGetAppliedCampaigns(
    influencerDetails?._id,
    campaignType,
    campaignStatus,
    approvalStatus
  );

  return (
    <div className="home_main">
      {/* <ScrollToTop /> */}
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="dashboard_main">
            <div className="dashboard_header">
              <h4>Dashboard</h4>
              <div className="logout_box">
                <ProfilePic onLogout={onLogout} />
              </div>
            </div>
            <Overview
              totalCampaign={allAppliedCampaigns?.totalCount}
              activeCampaigns={allAppliedCampaigns?.activeCount}
            />
            <div className="row mt-4">
              <div className="col-md-12">
                <CampaignsTable
                  isLoading={isLoading}
                  influencerDetails={allAppliedCampaigns?.campaigns}
                  page={page}
                  id={influencerDetails?._id}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  campaignType={campaignType}
                  setCampaignType={setCampaignType}
                  campaignStatus={campaignStatus}
                  setCampaignStatus={setCampaignStatus}
                  approvalStatus={approvalStatus}
                  setApprovalStatus={setApprovalStatus}
                />
              </div>
              {/* <div className="col-md-5 mt-4">
                <AppliedCampaignTable
                  isLoading={isLoading}
                  influencerDetails={influencerDetails}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
